<template>
  <div
    class="chart-content"
    v-loading="loading"
    element-loading-background="rgba(255,255,255, 1)"
  >
    <!-- <div class="header">
      <span>{{  }}</span>
    </div> -->
      <div :class="[showHeight==true ? ' charComHeight' : '', 'chart-component']">
      <chart
        ref="chartContent"
        @change-zoom="changeZoom"
        @click-chart="clickChart"
        @mouseover-chart="mouseOverChart"
        @mouseout-chart="mouseOutChart"
        :options="data.option"
        :type="data.type"
      ></chart>
    </div>
  </div>
</template>

<script>
import chart from '@/components/Chart/chart.vue'
export default {
  name: 'chartContent',
  components: {
    chart
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean
    },
    showHeight:{
       type: Boolean
    }
  },
  watch:{
     showHeight(val){
        this.showHeight=val
     }
  },
  created(){

  },
  methods: {
    changeZoom (val) {
      
      this.$emit('change-zoom', val.start, val.end)
    },
    clickChart (val) {

      this.$emit('click-chart', val)
    },
    mouseOverChart (val) {
      this.$emit('mouseover-chart', val)
    },
    mouseOutChart (val) {
      this.$emit('mouseout-chart', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-content {
  position: relative;
  width: 100%;
  height: 100%;
  .chart-component {
    // padding-top: 10px;
    width: 100%;
    height: 100%;
  }
  .charComHeight{
    height: 120%!important;
  }
}
</style>
